import mapSvg from '../../images/background-map-2024.svg';

export default class BlockMap {
  async init() {
    const mapBlocks = Array.from(document.querySelectorAll('.agency-map'));
    const svg = await this.loadSvgContent(mapSvg);

    mapBlocks.forEach((mapBlock) => {
      this.renderSvg(svg, mapBlock);
      this.setupHoverLinks(mapBlock);
    });
  }

  async loadSvgContent(svgPath) {
    const response = await fetch(svgPath);

    if (!response.ok) {
      return '';
    }

    return await response.text();
  }

  renderSvg(svg, mapBlock) {
    const mapContainer = mapBlock.querySelector('.agency-map__map');

    if (!mapContainer) {
      return;
    }

    mapContainer.innerHTML = svg;
    mapBlock.classList.add('loaded');
  }

  setupHoverLinks(mapBlock) {
    const agencyElements = Array.from(
      mapBlock.querySelectorAll('g[data-slug], .agency-map__agency[data-slug]')
    );

    agencyElements.forEach((agencyElement) => {
      const slug = agencyElement.dataset.slug;

      if (!slug) {
        return;
      }

      const element = mapBlock.querySelector(
        `.agency-map__agency[data-slug="${slug}"]`
      );
      const path = mapBlock.querySelector(`g[data-slug="${slug}"]`);

      for (let hoverableElement of [element, path]) {
        if (hoverableElement && element && path) {
          hoverableElement.addEventListener('mouseenter', () => {
            element.classList.add('hovered');
            path.classList.add('hovered');
          });
          hoverableElement.addEventListener('mouseleave', () => {
            element.classList.remove('hovered');
            path.classList.remove('hovered');
          });
        }
      }
    });
  }
}
